import { requestApi } from '../api';
import { BaseRepository } from './base';

// Задания привязаны к адресу подключённого кошелька, подпись не нужна
const options = { skipAuthRedirect: true };
const withAddress = (url, address) => `${url}?address=${address}`;

class Repository extends BaseRepository {
  getCurrent = (address) =>
    requestApi('get', withAddress(`${this.path}/current`, address), null, false, false, options);

  checkHold = (address) =>
    requestApi('post', withAddress(`${this.path}/hold/check`, address), null, false, false, options);

  claim = (address, id) =>
    requestApi('post', withAddress(`${this.path}/${id}/claim`, address), null, false, false, options);
}

export const QuestsRepository = new Repository('/quests');
